import { useEffect, useState } from 'react';
import { getAccessToken } from '../services/authService';
export default function useSubscriptionAccess() {
  const [access,setAccess]=useState({canEdit:false,canUseAI:false});
  useEffect(()=>{
    let mounted=true;
    const load=async()=>{
      try { const token=getAccessToken();if(!token)return;
        const res=await fetch(`${process.env.REACT_APP_DEV_API}/payment/subscription/access`,{headers:{Authorization:`Bearer ${token}`}});
        if(!res.ok)throw new Error('Access unavailable');
        const data=await res.json();if(mounted){setAccess(data);const user=JSON.parse(localStorage.getItem('user')||'null');if(user)localStorage.setItem('user',JSON.stringify({...user,subscriptionAccess:data}));}
      }catch(_){if(mounted)setAccess({canEdit:false,canUseAI:false});}
    };
    load();const timer=setInterval(load,30000);window.addEventListener('focus',load);window.addEventListener('subscription-updated',load);
    return()=>{mounted=false;clearInterval(timer);window.removeEventListener('focus',load);window.removeEventListener('subscription-updated',load);};
  },[]);
  return access;
}